import algoliasearch from 'algoliasearch';
export function createAlgoliaClient(algoliaConfig) {
  return algoliasearch(algoliaConfig.applicationId, algoliaConfig.apiKey);
}